import React from "react";
import GoogleMapReact from "google-map-react";
import Cookies from "js-cookie";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  geocodeByLatLng,
  getLatLng,
} from "react-google-places-autocomplete";
import { getWalkScoreData, getAutoPopulateData } from "../services/Form";
import IsMultiToggle from '../IsMultiToggle'
import useGlobalHeader from '../useGlobalHeader'
function NewAddress(props) {
  const [msg, setMsg] = React.useState('');
  const [tooglevalue, settooglevalue] = React.useContext(IsMultiToggle);
  const [loading, setLoading] = React.useState(false);
  const [auto, setauto] = React.useState(0);
  const [coords, setCoords] = React.useContext(useGlobalHeader);
  const [value, setValue] = React.useState(null);
  const [value2, setValue2] = React.useState("Undefined");

  React.useEffect(() => {

  }, []);
  function commafy(num) {
    var str = num.toString().split('.');
    if (str[0].length >= 5) {
      str[0] = str[0].replaceAll(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 5) {
      str[1] = str[1].replaceAll(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
  }
  const onChange = (lat, lng, auto = 1) => {
    setCoords({ lat: Number(lat), lng: Number(lng) });
    props.setData(
      props.data.map((item) => {
        if (item.ParameterId === props.id)
          return { ...item, Value: value2.label };
        if (item.ParameterId === 189) return { ...item, Value: lat };
        if (item.ParameterId === 190) return { ...item, Value: lng };
        else return item;
      })
    );
    if (auto == 0) {
      var PerClick = Cookies.get('UsedClicks');
      var PerMonthClick = Cookies.get('PerMonthClick');
      let num = parseInt(PerMonthClick, 10);
      let num1 = parseInt(PerClick, 10);

      if (num1 > num) {
        setMsg(" You have reached your limit,contact to admin.");
      }
      else {
        document.getElementById('param190').value = lng;
        document.getElementById('param189').value = lat;
        document.getElementById('addressnot1').style.display = "none";
        document.getElementById('addressnot1').innerText = "";
        document.getElementById('AddAddressString').innerText = value2.label.replace(/['"]+/g, "");
        Cookies.set('AddAddressString', value2.label.replace(/['"]+/g, ""))
        setLoading(true)
        getAutoPopulateData(lat, lng, value2.label).then((res) => {
          setLoading(false)
          if (res.length > 0) {
            let arr = [];
            arr = res[0].Ecas.split(",");
            arr = arr.map((item) => ({ value: item, label: item }));
            props.data.find((item) => item.ParameterId === 6).Value = "No";
            document.getElementById('param6').value = "";
            if (res[0].ZONING != 'NR3' && res[0].ZONING != 'NR2' && res[0].ZONING != 'NR1' && res[0].ZONING != 'RSL' && res[0].ZONING != 'LR1'
              && res[0].ZONING != 'LR2' && res[0].ZONING != 'LR3' && res[0].ZONING != 'MR') {
              document.getElementById('addressnot1').style.display = "block";
              document.getElementById('addressnot1').innerText = "We currently do not offer an analysis for this type of zoning.";
            }
            else {
              props.data.find((item) => item.ParameterId === 6).Value = res[0].ZONING;
              document.getElementById('param6').style.boxShadow = "1px 1px #2b67b2";
              document.getElementById('param6').value = res[0].ZONING;
            }

            props.data.find((item) => item.ParameterId === 3).Value = value2.label.replace(/['"]+/g, "");
            props.data.find((item) => item.ParameterId === 189).Value = lat;
            props.data.find((item) => item.ParameterId === 190).Value = lng;
            props.data.find((item) => item.ParameterId === 291).Value = res[0].PIN.replace(/['"]+/g, "");
            props.data.find((item) => item.ParameterId === 5).Value = res[0].LOT_SIZE;
            props.data.find((item) => item.ParameterId === 7).Value = res[0].MHA_SUFFIX;
            props.data.find((item) => item.ParameterId === 29).Value = res[0].MHA_AREA;
            props.data.find((item) => item.ParameterId === 4).Value = res[0].YEAR_BUILT;
            props.data.find((item) => item.ParameterId === 8).Value = res[0].TotalValue;
            props.data.find((item) => item.ParameterId === 197).Value = res[0].PRESENT_USE;
            props.data.find((item) => item.ParameterId === 218).Value = res[0].URBAN_VILLAGES;
            props.data.find((item) => item.ParameterId === 221).Value = res[0].HISTORICAL_DISTRICT;
            props.data.find((item) => item.ParameterId === 222).Value = res[0].OVERLAYS;
            settooglevalue(arr);

            props.data.find((item) => item.ParameterId === 195).Value = res[0].OPP_ZONE;
            props.data.find((item) => item.ParameterId === 196).Value = res[0].HISTORICAL_LANDMARK;
            props.data.find((item) => item.ParameterId === 220).Value = res[0].DESIGN_REVIEW_EQUITY;
            props.data.find((item) => item.ParameterId === 219).Value = res[0].FREQUENT_TRANSIT_SERVICE_AREA;
            props.data.find((item) => item.ParameterId === 228).Value = res[0].PARKING_FLEXIBILITY;
            props.data.find((item) => item.ParameterId === 9).Value = res[0].width;
            props.data.find((item) => item.ParameterId === 10).Value = res[0].length;
            props.data.find((item) => item.ParameterId === 13).Value = res[0].corner;
            props.data.find((item) => item.ParameterId === 16).Value = res[0].elevation;
            props.data.find((item) => item.ParameterId === 17).Value = res[0].SlopeDirection;

            document.getElementById("PresentOther").style.display = 'inline-block';
            document.getElementById("PresentUseID").style.display = 'none';
            document.getElementById('param291').value = res[0].PIN.replace(/['"]+/g, "");
            document.getElementById('param283').value = res[0].PRESENT_USE;
            document.getElementById('param5').value = res[0].LOT_SIZE;
            document.getElementById('param7').value = res[0].MHA_SUFFIX;
            document.getElementById('param29').value = res[0].MHA_AREA;
            document.getElementById('param4').value = res[0].YEAR_BUILT;
            document.getElementById('param8').value = commafy(res[0].TotalValue.replace(/['"]+/g, ""));
            document.getElementById('param197').value = res[0].PRESENT_USE;
            document.getElementById('param218').value = res[0].URBAN_VILLAGES;
            document.getElementById('param221').value = res[0].HISTORICAL_DISTRICT;

            document.getElementById('param195').value = res[0].OPP_ZONE;
            document.getElementById('param196').value = res[0].HISTORICAL_LANDMARK;
            document.getElementById('param220').value = res[0].DESIGN_REVIEW_EQUITY;
            document.getElementById('param219').value = res[0].FREQUENT_TRANSIT_SERVICE_AREA;
            document.getElementById('param228').value = res[0].PARKING_FLEXIBILITY;
            document.getElementById('param222').value = res[0].OVERLAYS;
            document.getElementById('param9').value = res[0].width;
            document.getElementById('param10').value = res[0].length;
            document.getElementById('param13').value = res[0].corner;
            document.getElementById('param16').value = res[0].elevation;
            document.getElementById('param17').value = res[0].SlopeDirection;

            document.getElementById('param14').value = res[0].alley;
            document.getElementById('param18').value = res[0].TreeCanopyCoverage;
            document.getElementById('param317').value = res[0].sidewalk;

            document.getElementById("siteinfo").href = "https://blue.kingcounty.com/Assessor/eRealProperty/Dashboard.aspx?ParcelNbr=" + res[0].PIN.replace(/['"]+/g, "");
            document.getElementById("geoana").href = "https://web.seattle.gov/dpd/ParcelData/Parcel.aspx?pin=" + res[0].PIN.replace(/['"]+/g, "");

            // document.getElementById('lable18').style.color="red";
            // document.getElementById('lable14').style.color="red";

            document.getElementById('param291').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param5').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param7').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param29').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param4').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param8').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param197').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param218').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param195').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param221').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param196').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param220').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param219').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param228').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param222').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param19').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param9').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param10').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param13').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param16').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param17').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param14').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param18').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param317').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById("btncontinue").disabled = false;
          }
          else {
            let result = value2.label.includes("\"") ? "Yes" : "No";
            if (result == "No") {
              props.setData(
                props.data.map((item) => {
                  if (item.ParameterId === 3)
                    return { ...item, Value: "No" };
                  if (item.ParameterId === 189) return { ...item, Value: "No" };
                  if (item.ParameterId === 190) return { ...item, Value: "No" };
                  else return item;
                })
              );

              document.getElementById('param190').value = "";
              document.getElementById('param189').value = "";
              document.getElementById('addressnot1').style.display = "block";
              document.getElementById('addressnot1').innerText = "We could not find a match to this address.";
              document.getElementById("btncontinue").disabled = true;
            }
          }
        });
        getWalkScoreData(lat, lng, value2.label).then((res) => {
          props.data.find((item) => item.ParameterId === 282).Value = res.scounscore;
          props.data.find((item) => item.ParameterId === 281).Value = res.walkscore;
          document.getElementById("param281").value = res.walkscore;
          document.getElementById("param282").value = res.scounscore;
        });
      }
    }
  }
  const onChangetext = (e) => {
    document.getElementById('param' + props.id).removeAttribute('style');
    const value = e.target.value;


    if (!isNaN(value)) {
      setValue(e.target.value);
      props.data.find((item) => item.ParameterId === 291).Value = value;
    }


    if (value.length < 10) {
      document.getElementById('param' + props.id).style.border = "2px solid red";
      document.getElementById("btncontinue").disabled = true;
    }
    else {
      var PerClick = Cookies.get('UsedClicks');
      var PerMonthClick = Cookies.get('PerMonthClick');
      let num = parseInt(PerMonthClick, 10);
      let num1 = parseInt(PerClick, 10);

      if (num1 > num) {
        setMsg(" You have reached your limit,contact to admin.");
      }
      else {
        setauto(1);
        setLoading(true)
        document.getElementById('addressnot1').style.display = "none";
        getAutoPopulateData("5", "", value).then((res) => {

          setLoading(false);


          if (res.length > 0) {



            let arr = [];
            arr = res[0].Ecas.split(",");
            arr = arr.map((item) => ({ value: item, label: item }));
            props.data.find((item) => item.ParameterId === 6).Value = "No";
            document.getElementById('param6').value = "";
            document.getElementById('AddAddressString').innerText = res[0].ADDRESS.replace(/['"]+/g, "");
            Cookies.set('AddAddressString', res[0].ADDRESS.replace(/['"]+/g, ""))
            if (res[0].ZONING != 'NR3' && res[0].ZONING != 'NR2' && res[0].ZONING != 'NR1' && res[0].ZONING != 'RSL' && res[0].ZONING != 'LR1'
              && res[0].ZONING != 'LR2' && res[0].ZONING != 'LR3' && res[0].ZONING != 'MR') {
              document.getElementById('addressnot1').style.display = "block";
              document.getElementById('addressnot1').innerText = "We currently do not offer an analysis for this type of zoning.";
            }
            else {
              props.data.find((item) => item.ParameterId === 6).Value = res[0].ZONING;
              document.getElementById('param6').style.boxShadow = "1px 1px #2b67b2";
              document.getElementById('param6').value = res[0].ZONING;
            }
            //onChange(res[0].LATITUDE, res[0].LONGITUDE,1);
            //alert(res[0].ADDRESS);

            props.data.find((item) => item.ParameterId === 3).Value = res[0].ADDRESS.replace(/['"]+/g, "");
            props.data.find((item) => item.ParameterId === 189).Value = res[0].LATITUDE;
            props.data.find((item) => item.ParameterId === 190).Value = res[0].LONGITUDE;
            props.data.find((item) => item.ParameterId === 5).Value = res[0].LOT_SIZE;
            props.data.find((item) => item.ParameterId === 7).Value = res[0].MHA_SUFFIX;
            props.data.find((item) => item.ParameterId === 29).Value = res[0].MHA_AREA;
            props.data.find((item) => item.ParameterId === 4).Value = res[0].YEAR_BUILT;
            props.data.find((item) => item.ParameterId === 8).Value = res[0].TotalValue;
            props.data.find((item) => item.ParameterId === 197).Value = res[0].PRESENT_USE;
            props.data.find((item) => item.ParameterId === 218).Value = res[0].URBAN_VILLAGES;
            props.data.find((item) => item.ParameterId === 221).Value = res[0].HISTORICAL_DISTRICT;
            props.data.find((item) => item.ParameterId === 222).Value = res[0].OVERLAYS;


            props.data.find((item) => item.ParameterId === 195).Value = res[0].OPP_ZONE;
            props.data.find((item) => item.ParameterId === 196).Value = res[0].HISTORICAL_LANDMARK;
            props.data.find((item) => item.ParameterId === 220).Value = res[0].DESIGN_REVIEW_EQUITY;
            props.data.find((item) => item.ParameterId === 219).Value = res[0].FREQUENT_TRANSIT_SERVICE_AREA;
            props.data.find((item) => item.ParameterId === 228).Value = res[0].PARKING_FLEXIBILITY;

            props.data.find((item) => item.ParameterId === 9).Value = res[0].width;
            props.data.find((item) => item.ParameterId === 10).Value = res[0].length;
            props.data.find((item) => item.ParameterId === 13).Value = res[0].corner;
            props.data.find((item) => item.ParameterId === 16).Value = res[0].elevation;
            props.data.find((item) => item.ParameterId === 17).Value = res[0].SlopeDirection;

            var lat = res[0].LATITUDE;
            var lng = res[0].LONGITUDE;
            //console.log(coords);
            setCoords({ lat: Number(lat), lng: Number(lng) });

            //setValue2({ label: res[0].ADDRESS.replace(/['"]+/g, "") });
            document.getElementById('param291').value = res[0].PIN.replace(/['"]+/g, "");
            document.getElementById('param190').value = res[0].LONGITUDE;
            document.getElementById('param189').value = res[0].LATITUDE;
            document.getElementById("PresentOther").style.display = 'inline-block';
            document.getElementById("PresentUseID").style.display = 'none';
            document.getElementById('param283').value = res[0].PRESENT_USE;
            document.getElementById('param5').value = res[0].LOT_SIZE;
            document.getElementById('param7').value = res[0].MHA_SUFFIX;
            document.getElementById('param29').value = res[0].MHA_AREA;
            document.getElementById('param4').value = res[0].YEAR_BUILT;
            document.getElementById('param8').value = commafy(res[0].TotalValue.replace(/['"]+/g, ""));
            document.getElementById('param197').value = res[0].PRESENT_USE;
            document.getElementById('param218').value = res[0].URBAN_VILLAGES;
            document.getElementById('param221').value = res[0].HISTORICAL_DISTRICT;
            document.getElementById('param195').value = res[0].OPP_ZONE;
            document.getElementById('param196').value = res[0].HISTORICAL_LANDMARK;
            document.getElementById('param220').value = res[0].DESIGN_REVIEW_EQUITY;
            document.getElementById('param219').value = res[0].FREQUENT_TRANSIT_SERVICE_AREA;
            document.getElementById('param228').value = res[0].PARKING_FLEXIBILITY;
            document.getElementById('param222').value = res[0].OVERLAYS;

            document.getElementById('param9').value = res[0].width;
            document.getElementById('param10').value = res[0].length;
            document.getElementById('param13').value = res[0].corner;
            document.getElementById('param16').value = res[0].elevation;
            document.getElementById('param17').value = res[0].SlopeDirection;
            document.getElementById('param14').value = res[0].alley;
            document.getElementById('param18').value = res[0].TreeCanopyCoverage;
            document.getElementById('param317').value = res[0].sidewalk;
            document.getElementById("siteinfo").href = "https://blue.kingcounty.com/Assessor/eRealProperty/Dashboard.aspx?ParcelNbr=" + res[0].PIN.replace(/['"]+/g, "");
            document.getElementById("geoana").href = "https://web.seattle.gov/dpd/ParcelData/Parcel.aspx?pin=" + res[0].PIN.replace(/['"]+/g, "");

            settooglevalue(arr);
            //  document.getElementById('lable18').style.color="red";
            //  document.getElementById('lable14').style.color="red";
            document.getElementById('param5').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param7').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param29').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param4').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param8').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param197').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param218').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param195').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param221').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param196').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param220').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param219').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param228').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param222').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param19').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param9').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param10').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param13').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param16').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param17').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param14').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param18').style.boxShadow = "1px 1px #2b67b2";
            document.getElementById('param317').style.boxShadow = "1px 1px #2b67b2";

            getWalkScoreData(res[0].LATITUDE, res[0].LONGITUDE, res[0].ADDRESS.replace(/['"]+/g, "")).then((res) => {

              props.data.find((item) => item.ParameterId === 282).Value = res.scounscore;
              props.data.find((item) => item.ParameterId === 281).Value = res.walkscore;
              document.getElementById("param281").value = res.walkscore;
              document.getElementById("param282").value = res.scounscore;
              console.log(props)
              document.getElementById("btncontinue").disabled = false;
            });

          }

          else {
            props.data.find((item) => item.ParameterId === 3).Value = "No";
            props.data.find((item) => item.ParameterId === 189).Value = "No";
            props.data.find((item) => item.ParameterId === 190).Value = "No";
            document.getElementById('param190').value = "";
            document.getElementById('param189').value = "";
            document.getElementById('addressnot1').style.display = "block";
            document.getElementById('addressnot1').innerText = "We could not find a match to this address.";
            document.getElementById("btncontinue").disabled = true;
          }
          console.log(props)
        });
        document.getElementById('param' + props.id).style.border = "1px solid rgba(0, 0, 0, 0.2)";
      }
    }

  }
  React.useEffect(() => {
    (async () => {


      if (value2 != 'Undefined') {


        geocodeByAddress(value2.label)
          .then((results) => getLatLng(results[0]))
          .then(({ lat, lng }) => {
            onChange(Number(lat), Number(lng), 0);

          });

      }

    })();
  }, [value2]);

  const myFunc = ({ map, maps }) => {
    var marker = new maps.Marker({
      map: map,
      animation: maps.Animation.DROP,
      position: { lat: coords.lat, lng: coords.lng },
    });
  };


  if (props.id == 2913) {
    console.log("here");
    return (
      <>
        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
        <label style={{ color: "white" }}>{props.name}</label>
        <span style={{ color: 'red', fontSize: "10px" }}>{msg}</span>
        <input class="form-control newreport" placeholder="Parcel #" onChange={onChangetext} id={'param' + props.id}>


        </input>

      </>

    );
  }
  else {
    return (
      <>


        {/* <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={props.name}
          class="form-control"
        /> */}
        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
        <label style={{ color: "white" }}> {props.name}</label> <span style={{ color: 'red', fontSize: "10px" }}>{msg}</span>

        <GooglePlacesAutocomplete
          selectProps={{
            value2,
            onChange: setValue2,
          }}
        />







      </>
    );
  }
}
export default NewAddress